/** @jsx jsx */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import '../Home.css';
import SSRf from 'orbiter-web/lib/SSR';
import { jsx, css } from '@emotion/core';
import FullScreenImage from 'orbiter-web-components/src/components/fullScreenImage/FullScreenImage';
import Map from 'orbiter-web-components/src/components/map/Map';
import { Container, Row, Col } from 'react-bootstrap';
import { noPaddingStyling, contentContainerStyling, containerStyling, ColStyling, contentStyling, contentLogoStyling, sectionTitleStyling, centerStyling, mapStyling } from '../homeCSS';
import TopCard from 'orbiter-web-components/src/components/card/TopCard';
class Contact extends React.Component {
    static loadServerData(props) {
        return __awaiter(this, void 0, void 0, function* () {
            const q = __non_webpack_require__('orbiter-core/src/MongoDatabaseConnection');
            const dbConn = yield q.default();
            const collection = yield dbConn.getCollection('sections');
            let adres = yield collection.findOne({ strid: 'adres' });
            adres = adres.content.NL;
            let contactgegevens = yield collection.findOne({ strid: 'contactgegevens' });
            contactgegevens = contactgegevens.content.NL;
            let contactTitel = yield collection.findOne({ strid: 'contact titel' });
            contactTitel = contactTitel.content.NL;
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve({
                        test: 'to SSR!',
                        contact: { adres, contactgegevens, contactTitel },
                    });
                }, 500);
            });
        });
    }
    constructor(a) {
        super(a);
    }
    render() {
        if (this.props.contact === undefined) {
            return null;
        }
        return (jsx(FullScreenImage, { onClick: this.props.onClick, contentContainerStyle: contentContainerStyling, backgroundImage: "/images/backgrounds/contact.jpg", nextPageImage: "/images/arrowButtons/arrowBottom.svg" },
            jsx(Container, { css: (t) => [containerStyling(t), noPaddingStyling(t)] },
                jsx(Row, { css: centerStyling },
                    jsx(Col, { md: 12, css: ColStyling },
                        jsx(TopCard, { imageSrc: "/images/icons/phone-booth.svg", titleStyle: (t) => [sectionTitleStyling(t), this.props.colorCombination(t)], cardStyle: contentStyling, imageStyle: contentLogoStyling, title: this.props.contact.contactTitel, center: true },
                            jsx(Col, { sm: 6, css: (t) => {
                                    return css `
                                            display: inline-block;
                                            padding: 5px;
                                        `;
                                } },
                                jsx("p", { css: this.props.colorCombination, dangerouslySetInnerHTML: { __html: this.props.contact.adres } })),
                            jsx(Col, { sm: 6, css: (t) => {
                                    return css `
                                            display: inline-block;
                                            padding: 5px;
                                        `;
                                } },
                                jsx("p", { css: this.props.colorCombination, dangerouslySetInnerHTML: { __html: this.props.contact.contactgegevens } })))),
                    jsx(Col, { md: 12, css: centerStyling },
                        jsx(Map, { map: mapStyling, height: "250px", url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1251.824981748709!2d5.458151146972312!3d51.13336432553552!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c129f655b6989d%3A0x61bc5c98cd3d3c38!2sS%20%26%20P%20bvba!5e0!3m2!1snl!2sbe!4v1566823613052!5m2!1snl!2sbe" }))))));
    }
}
export default SSRf(Contact);
//# sourceMappingURL=Contact.js.map